module.exports = __webpack_public_path__ + "img/awards_image_02.2532b25a.jpg";